import React, { useEffect, useState } from "react";
import { get_affiliated_client } from "../../../DAL/clientTypes/ClientTpes";
import CircularLoader from "../../../components/loader/CircularLoader";
import { enqueueSnackbar } from "notistack";
import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import ClientHoverImageCard from "../../clientTypes/components/ClientHoverImageCard";
import CompanyPopup from "../../../components/popUp/CompanyPopup";
import { useIds } from "../../../hook/AdminContext";
import RecordNoImage from "../../../components/recordNotFound/RecordNoImage";
import { useNavigate } from "react-router-dom";

export default function ClientAffiliates({ clientId }) {
  const { userInfo } = useIds();
  const navigate = useNavigate();
  const [affiliateList, setAffiliateList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [targetClient, setTargetClient] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);

  const handleGetAffiliatedClients = async () => {
    const resp = await get_affiliated_client(clientId);
    if (resp.code == 200) {
      setAffiliateList(resp.data.receiver);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }

    setLoading(false);
  };

  useEffect(() => {
    handleGetAffiliatedClients();
  }, []);

  if (loading) {
    return <CircularLoader />;
  }
  return (
    <>
      {openDetails && (
        <CompanyPopup
          companyModalOpen={openDetails}
          handleCloseCompanyModal={() => setOpenDetails(false)}
          companyModalData={targetClient}
        />
      )}

      <div className="my-3">
        <div className="d-flex justify-content-between align-items-start">
          <h3 className="profile-section-heading">Affiliates</h3>
        </div>

        {affiliateList.length > 0 ? (
          <div className="row">
            {affiliateList.map((item) => (
              <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                <ClientHoverImageCard
                  client={
                    item?.receiver_object?._id == clientId
                      ? item?.sender_object
                      : item?.receiver_object
                  }
                  source_slug={""}
                  type_slug={""}
                  handleNavigateDetails={(item) => {
                    // setTargetClient(item);
                    // setOpenDetails(true);
                    navigate("/user");

                    setTimeout(() => {
                      navigate("/user/" + item._id);
                    }, 100);
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-5">
            <RecordNoImage title={"Affiliates Not Found"} />
          </div>
        )}
      </div>
    </>
  );
}
